module.exports = __webpack_public_path__ + "img/banner3_2_zh.071bb9a2.png";